import { BLOCK_TYPES } from "../../common";
import { renderEditorCrossword } from "../Crossword";

const { SCRATCH_ARRANGE_LIST_BLOCK } = BLOCK_TYPES;

const renderEditor = (props: any) =>
    renderEditorCrossword({
        ...props,
        blockType: SCRATCH_ARRANGE_LIST_BLOCK,
        showFeedback: true,
    });

export default renderEditor;
